import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Root from './components/Root';
import Login from './features/auth/routes/Login';
import RequireAuth from './routes/RequireAuth';
import { predictionMapRoutes } from './features/predictionMap/routes';
import { alertRoutes } from './features/alerts/routes';
import authLoader from './routes/authLoader';
import { customerRoutes } from './features/client/router';
import SignUp from './features/auth/routes/SignUp';
import UnmemberRoot from './components/UnmemberRoot';
import { ApplicationPage } from './features/auth/routes/ApplicationPage';
import { helpRoutes } from './features/help/router';
import { sendPageView } from './utils/googleAnalytics';

const router = createBrowserRouter([
  {
    path: '/',
    element: <UnmemberRoot />,
    loader: authLoader,
    children: [
      {
        path: '',
        element: <Login />,
      },
      {
        path: 'application',
        element: <ApplicationPage />,
      },
      {
        path: '*',
        element: <Login />,
      },
      {
        path: 'signup',
        element: <SignUp />,
      },
      {
        path: 'application',
        element: <ApplicationPage />,
      },
      {
        path: '*',
        element: <Login />,
      },
    ],
  },
  {
    path: 'prediction',
    element: (
      <RequireAuth>
        <Root />
      </RequireAuth>
    ),
    loader: authLoader,
    children: [...predictionMapRoutes, ...alertRoutes, ...customerRoutes, ...helpRoutes],
  },
]);

const getPath = () => {
  const { pathname, search, hash } = router.state.location;
  return `${pathname}${search}${hash}`;
};

let currentPath = getPath();
// GA4: 初回表示のページビューを計測
sendPageView(currentPath);

router.subscribe(() => {
  const nextPath = getPath();
  if (nextPath === currentPath) {
    return;
  }

  currentPath = nextPath;
  // GA4: SPA内の画面遷移をページビューとして計測
  sendPageView(nextPath);
});

function App() {
  return <RouterProvider router={router} />;
}

export default App;
